(function () {
  const slideUp = (element, duration = 300) => {
    if (!element) return;
    element.style.height = `${element.scrollHeight}px`;
    element.style.overflow = "hidden";
    element.style.transition = `height ${duration}ms ease`;

    requestAnimationFrame(() => {
      element.style.height = "0";
    });

    setTimeout(() => {
      element.style.display = "none";
      element.style.removeProperty("height");
      element.style.removeProperty("overflow");
      element.style.removeProperty("transition");
    }, duration);
  };

  const slideDown = (element, duration = 300) => {
    if (!element) return;

    element.style.removeProperty("display");
    let display = window.getComputedStyle(element).display;
    if (display === "none") display = "block";
    element.style.display = display;

    const height = element.scrollHeight;
    element.style.height = "0";
    element.style.overflow = "hidden";
    element.style.transition = `height ${duration}ms ease`;

    requestAnimationFrame(() => {
      element.style.height = `${height}px`;
    });

    setTimeout(() => {
      element.style.removeProperty("height");
      element.style.removeProperty("overflow");
      element.style.removeProperty("transition");
    }, duration);
  };

  const toggleItem = (item, allItems) => {
    const answer = item.querySelector(".collapsible-content__answer");
    const isActive = item.classList.contains("active");

    // Close other items
    allItems.forEach((other) => {
      if (other !== item && other.classList.contains("active")) {
        other.classList.remove("active");
        const ans = other.querySelector(".collapsible-content__answer");
        slideUp(ans);
      }
    });

    // Toggle this one
    if (isActive) {
      item.classList.remove("active");
      slideUp(answer);
    } else {
      item.classList.add("active");
      slideDown(answer);
    }
  };

  const initCollapsibles = (section) => {
    if (!section) return;
    const items = section.querySelectorAll(".collapsible-content__item");
    if (!items.length) return;

    items.forEach((item) => {
      const btn = item.querySelector(".collapsible-content__toggle");
      if (!btn) return;

      btn.addEventListener("click", (event) => {
        event.preventDefault();
        toggleItem(item, items); // ✅ This is the correct function name
      });
    });
  };

  // On page load
  document.addEventListener("DOMContentLoaded", () => {
    const collapsibleSections = document.querySelectorAll(".collapsible-content.mobile-faqs");
    collapsibleSections.forEach((section) => {
      initCollapsibles(section);
    });
  });

  // On Shopify section reload
  document.addEventListener("shopify:section:load", (event) => {
    const section = event.target.querySelector(".collapsible-content.mobile-faqs");
    if (section) {
      initCollapsibles(section);
    }
  });
})();
